import React, { useState } from 'react';
import { Typography, Modal, Button } from 'antd';

const { Paragraph, Text } = Typography;

function ErrorModal({ errorList, isVisible, title, showAll }) {
  const [showModal, setShowModal] = useState(false);

  if (!errorList?.length) return null;

  // showAll: render every item directly as a list (no modal, no "Show more")
  if (showAll) {
    return (
      <ul style={{ paddingLeft: 16, margin: 0 }}>
        {errorList.map((message, index) => (
          <li key={index}>
            <Paragraph type='danger'>{message}</Paragraph>
          </li>
        ))}
      </ul>
    );
  }

  // default: existing single-item + "Show more" modal behaviour
  return (
    <>
      <div>
        <Paragraph
          ellipsis={{
            rows: 3,
          }}
          type='danger'
        >
          {errorList[0]}
        </Paragraph>
        {errorList.length > 1 && (
          <Text style={styles.showMore} onClick={() => setShowModal(true)}>
            Show more
          </Text>
        )}
      </div>
      {showModal && (
        <Modal
          title={title}
          centered
          visible={showModal}
          onOk={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          width={1000}
          destroyOnClose
          footer={
            <Button key='ok' type='primary' onClick={() => setShowModal(false)}>
              Ok
            </Button>
          }
          bodyStyle={{ height: '70vh', overflow: 'auto' }}
        >
          <ul>
            {errorList?.map((message) => (
              <li>
                <Paragraph type='danger' copyable={{ tooltips: false }}>
                  {message}
                </Paragraph>
              </li>
            ))}
          </ul>
        </Modal>
      )}
    </>
  );
}

export default ErrorModal;

const styles = {
  showMore: {
    cursor: 'pointer',
    color: '#1890ff',
    float: 'right',
  },
};
